// PricingSection.js
import React, { useEffect, useState } from "react";
import "./Body.css";
import { Link } from "react-router-dom";
import { FaLightbulb, FaMedal, FaHandshake, FaRupeeSign } from "react-icons/fa";
import Testimonial from "../Testimonial/Testimonial";
import axios from "axios";

const Body = () => {
  const services = [
    { name: "SEO", price: "₹9999", period: "/ Month" },
    { name: "PPC", price: "₹11999", period: "/ Month" },
    { name: "Social Media", price: "₹5999", period: "/ Month" },
    { name: "Digital Marketing", price: "₹9999", period: "/ Month" },
    { name: "Link Building", price: "₹10999", period: "/ Month" },
  ];

  const [selectedService, setSelectedService] = useState("UI/UX Optimization");

  const serviceDetails = {
    "UI/UX Optimization": {
      title: "UI/UX Optimization",
      description:
        "We enhance your website interface and user experience to increase engagement and conversions. Our experts analyze user behavior to create intuitive designs that drive results.",
    },
    "Pay-Per-Click Advertising (PPC)": {
      title: "Pay-Per-Click Advertising",
      description:
        "Our targeted PPC campaigns deliver immediate traffic and leads. We optimize your ad spend to maximize ROI through careful keyword selection and bidding strategies.",
    },
    "Social Media Marketing": {
      title: "Social Media Marketing",
      description:
        "We build your brand presence across social platforms with engaging content and strategic campaigns tailored to your audience demographics and behaviors.",
    },
    "Content Creation": {
      title: "Content Creation",
      description:
        "Our team develops high-quality, SEO-optimized content that resonates with your audience and establishes your brand as an industry authority.",
    },
    "Conversion Rate Optimization (CRO)": {
      title: "Conversion Rate Optimization",
      description:
        "We systematically improve your website to convert more visitors into customers through A/B testing, heatmaps, and user flow analysis.",
    },
    "Digital PR": {
      title: "Digital PR",
      description:
        "We amplify your brand message through strategic media placements, influencer partnerships, and online reputation management.",
    },
    "Website Testing": {
      title: "Website Testing",
      description:
        "Comprehensive testing ensures your website performs flawlessly across all devices and browsers, providing a seamless user experience.",
    },
    "Email Marketing": {
      title: "Email Marketing",
      description:
        "Our targeted email campaigns nurture leads and retain customers with personalized content and automated workflows that drive engagement.",
    },
    Remarketing: {
      title: "Remarketing",
      description:
        "We reconnect with visitors who didn't convert, bringing them back with tailored messages and offers that address their specific interests.",
    },
  };

  const approaches = {
    "UI/UX Optimization": [
      "We analyze heatmaps and user recordings to identify pain points in your current interface.",
      "Our designers create wireframes and prototypes based on industry best practices.",
      "We implement A/B testing to validate design changes before full deployment.",
    ],
    "Pay-Per-Click Advertising (PPC)": [
      "We conduct thorough keyword research to identify high-intent search terms.",
      "Our team creates compelling ad copy that speaks directly to your target audience.",
      "We continuously monitor and optimize campaigns based on performance data.",
    ],
    "Social Media Marketing": [
      "We develop a content calendar tailored to each platform's unique audience.",
      "Our team engages with followers to build community and brand loyalty.",
      "We track metrics to understand what content performs best and why.",
    ],
    // Add approaches for other services similarly
  };

  const principles = [
    {
      icon: <FaLightbulb />,
      title: "Knowledge",
      text: "SEO and Digital Marketing thrive on constant research and updates. Our Mission, Keep our client ahead of the curve.",
    },
    {
      icon: <FaMedal />,
      title: "Quality",
      text: "Quality services are our hallmark. Google appreciates our work, which is why we rank for 5 million keywords and have generated 1 million leads. As a result, 70% of our clients come from referrals.",
    },
    {
      icon: <FaHandshake />,
      title: "Trust",
      text: "We are very transparent with our customers and very strict about maintaining client privacy.",
    },
    {
      icon: <FaRupeeSign />,
      title: "Affordable",
      text: "We are affordable because we cater to startups, SMBs & Enterprises, offering services that support their Digital growth at a low cost. This has led to 40% of our revenue coming from rewards and bonuses.",
    },
  ];

  const seoServiceItems = [
    {
      iconSymbol: "📝",
      serviceHeading: "Content Writing and Marketing Services",
      serviceDetails:
        "Create and distribute SEO-friendly high quality solutions to deploy your brand new tools and utilising it elements in front of a captive audience.",
    },
    {
      iconSymbol: "📍",
      serviceHeading: "Local and Hyperlocal SEO",
      serviceDetails:
        "Get your business to appear in local and location-related searches with a Google Business Profile optimized for easierly the right audience to find you.",
    },
    {
      iconSymbol: "🌐",
      serviceHeading: "Multilingual and Global SEO",
      serviceDetails:
        "Howard Inc. innovates potential of regional languages and connects with new audiences and markets that get going quickly and into China's higher localities across content use networks with varied customers.",
    },
    {
      iconSymbol: "🔗",
      serviceHeading: "Link Building Services",
      serviceDetails:
        "Create a strong backlink profile and publish your contents on authoritative, close websites to showcase your expertise.",
    },
    {
      iconSymbol: "🛒",
      serviceHeading: "eCommerce SEO",
      serviceDetails:
        "Stand out in a competitive marketplace by improving your SEER visibility and residing with highly optimized product and category pages.",
    },
    {
      iconSymbol: "📈",
      serviceHeading: "Conversion Rate Optimization (CRO)",
      serviceDetails:
        "Improve your customer engagement, conversion rates, and revenue ratio after conversion from East Districation services. We help you use a substantial gain in your overall revenues.",
    },
    {
      iconSymbol: "⚠️",
      serviceHeading: "Google Penalty Recovery",
      serviceDetails:
        "If your website has recently experienced a sudden and significant drop in ranking and traffic, you may have seen her with a Google growth, Or heaven can help.",
    },
    {
      iconSymbol: "👥",
      serviceHeading: "Online Reputation Management",
      serviceDetails:
        "Build trust and credibility with comprehensive resolution monitoring and response management services from Themsegrees.",
    },
    {
      iconSymbol: "🔍",
      serviceHeading: "Technical SEO Audit",
      serviceDetails:
        "Comprehensive analysis of your website's technical infrastructure to identify and fix issues affecting search engine visibility and crawling efficiency.",
    },
  ];

  const handleServiceClick = (service) => {
    setSelectedService(service);
  };

  const seoPhrases = [
    "🚀 Boost Traffic",
    "📈 Rank #1 on Google",
    "💡 Drive More Leads",
    "🔍 Improve Visibility",
    "🧠 Smart SEO Strategies",
    "⚡ Lightning-Fast Performance",
  ];

  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    budget: "",
  });

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
  const response = await axios.post("https://justseo.in/api/sendemail", formData);
  console.log(response.data);
  setShowSuccess(true);
  setFormData({ name: "", phone: "", email: "", budget: "" });

  // Auto-hide after 3 seconds
  setTimeout(() => setShowSuccess(false), 3000);
} catch (error) {
  console.error("Error sending message:", error);
  alert("Failed to send message.");
}

  };

  return (
    <div>
      {/* <div className="marquee-wrapper">
        <div className="marquee-content">
          <span>
            🎯👑 Be #1 on Google! 🌍 Grow Visibility, Build Trust, Win Customers
            💚
          </span>
          <span>
            🌟⚡️ Boost Visibility. Drive Traffic. Dominate the Rankings! 🚀
          </span>
          <span>
            🚀💙 Rank High. Get Noticed. Grow Strong! 🌐 Your SEO Success Starts
            Here!
          </span>
        </div>
      </div> */}
{showSuccess && (
            <div className="popup-success">
              <p>Form submitted. Now let’s make search engines love you!</p>
            </div>
          )}
      <div className="seo-anim-wrapper">
        <div className="seo-anim-heading">Your SEO Journey Starts Here</div>
        <div className="seo-anim-marquee">
          <div className="seo-anim-track">
            {seoPhrases.concat(seoPhrases).map((text, index) => (
              <div className="seo-anim-item" key={index}>
                {text}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="seo-container">
        <div className="seo-form-container">
          <h2 className="form-title">SEO That’s Out of This World</h2>
          
          <form className="seo-form" onSubmit={sendEmail}>
            <div className="seo-form-group">
              <input
                type="text"
                className="seo-text-input"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                required
              />
            </div>
            <div className="seo-form-group">
              <input
                type="email"
                className="seo-email-input"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </div>
            <div className="seo-form-group">
              <input
                type="tel"
                className="seo-tel-input"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                required
              />
            </div>
            <div className="seo-form-group">
              <select
                className="seo-budget-select"
                name="budget"
                value={formData.budget}
                onChange={(e) =>
                  setFormData({ ...formData, budget: e.target.value })
                }
                required
              >
                <option value="" disabled>
                  Monthly Budget
                </option>
                <option value="1000-2500">₹1,000 - ₹2,500</option>
                <option value="2500-5000">₹2,500 - ₹5,000</option>
                <option value="5000-10000">₹5,000 - ₹10,000</option>
                <option value="10000-25000">₹10,000 - ₹25,000</option>
                <option value="25000+">₹25,000+</option>
              </select>
            </div>
            <button className="seo-submit-btn" type="submit">
              Send
            </button>

            {/* {submitStatus === 'success' && (
        <div className="seo-form-success">
          Thank you! Your message has been sent successfully.
        </div>
      )}
      {submitStatus === 'error' && (
        <div className="seo-form-error">
          Something went wrong. Please try again later.
        </div>
      )} */}
          </form>
        </div>

        <div className="seo-content-container">
          {/* <div className="seo-bot seo-bot-1"></div>
  <div className="seo-bot seo-bot-2"></div>
  <div className="seo-bot seo-bot-3"></div>
  
  <div className="keyword-bubble keyword-1">Keyword Research</div>
  <div className="keyword-bubble keyword-2">Backlinks</div>
  <div className="keyword-bubble keyword-3">On-Page SEO</div>
    <div className="keyword-bubble keyword-1">Keyword Research</div>
  
    <div className="keyword-bubble">Technical SEO</div> */}
          {/* <div className="keyword-bubble">Content Marketing</div>
  <div className="keyword-bubble">SERP Analysis</div>
  <div className="keyword-bubble">Meta Tags</div>
  <div className="keyword-bubble">Link Building</div>
  <div className="keyword-bubble">Mobile Optimization</div> */}
          {/* <div className="keyword-bubble">Page Speed</div> */}
          {/* <div className="keyword-bubble">Schema Markup</div> */}
          {/* <div className="keyword-bubble">Local SEO</div> */}
          {/* <div className="keyword-bubble">Keyword Research</div>
  <div className="keyword-bubble">Backlink Strategy</div>
  <div className="keyword-bubble">On-Page SEO</div>
  <div className="keyword-bubble">Technical SEO</div>
  <div className="keyword-bubble">Content Marketing</div>
  <div className="keyword-bubble">SERP Analysis</div>
  <div className="keyword-bubble">Meta Tags</div>
  <div className="keyword-bubble">Link Building</div>
  <div className="keyword-bubble">Mobile Optimization</div>
  <div className="keyword-bubble">Page Speed</div>
  <div className="keyword-bubble">Schema Markup</div>
  <div className="keyword-bubble">Local SEO</div>
  <div className="keyword-bubble">SEO Audits</div>
  <div className="keyword-bubble">Voice Search</div> */}
          {/* <div className="keyword-bubble">Featured Snippets</div>
  <div className="keyword-bubble">Image Optimization</div>
  <div className="keyword-bubble">UX Signals</div>
  <div className="keyword-bubble">Canonical Tags</div>
  <div className="keyword-bubble">Structured Data</div>
  <div className="keyword-bubble">Core Web Vitals</div>
  <div className="keyword-bubble">Bounce Rate</div>
  <div className="keyword-bubble">CTR Optimization</div>
  <div className="keyword-bubble">Domain Authority</div>
  <div className="keyword-bubble">Semantic Search</div>
  <div className="ranking-bar ranking-1"></div>
  <div className="ranking-bar ranking-2"></div>
  <div className="ranking-bar ranking-3"></div> */}

          <h1 className="seo-title">
            Scale Your Site Leads <br /> and Traffic with JustSEO <br />{" "}
            Enterprise SEO Services
          </h1>
          <div className="seo-subtitle">
            Delivering Results in Just 12 Months
          </div>
          <div className="seo-stats">
            <div className="stat-item">
              <div className="stat-value">Avg.83%</div>
              <div className="stat-label">Growth in Leads</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">Avg.121%</div>
              <div className="stat-label">Growth in Traffic</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">Avg.59%</div>
              <div className="stat-label">Growth in Top 10 Keywords</div>
            </div>
          </div>
        </div>
      </div>

      <div className="services-container-main">
        <h1 className="services-primary-title">SEO Services We Offer</h1>
        <h2 className="services-secondary-title">Enterprise SEO Services</h2>
        <p className="services-description-text">
          We offer SEO services for Enterprise-free websites with a large number
          of pages with deep expertise, tailored strategies, and rigorous
          adoption in ensuring successful SEER results.
        </p>

        <div className="services-grid-layout">
          {seoServiceItems.map((item, index) => (
            <div className="service-item-card" key={`service-${index}`}>
              <div className="service-icon-container">{item.iconSymbol}</div>
              <h3 className="service-item-title">{item.serviceHeading}</h3>
              <p className="service-item-description">{item.serviceDetails}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="pricing-section">
        <div className="pricing-header">
          <h2>Our Cost Effective</h2>
          <h1>Service Pricing</h1>
          <p>
            Our mission is to make digital marketing affordable for startups,
            SMEs and enterprises, helping them grow first. Because of these
            efforts, we earned thousands of heartfelt rewards from gradual
            clients around the world. As a top digital marketing agency, we
            believe that every business deserves a chance to thrive online, and
            we're here to make that happen for you.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <h3>{service.name}</h3>
              <div className="price">
                <span>Starting From</span>
                <div className="price-amount">
                  {service.price} <span>{service.period}</span>
                </div>
              </div>
              <button className="explore-btn">Explore</button>
              <Link to="/contact-us">
                <button className="contact-btn">Contact Us</button>
              </Link>
            </div>
          ))}
        </div>

        <div className="leads-section">
          <h1>How We Drive Leads & Sales With Digital Marketing</h1>
          <p className="leads-intro">
            To successfully drive leads and sales, you need professional digital
            marketing services that provide unique strategies for your business.
            And here we are. We concentrate on aligning all materiality channels
            to work together in drawing attention, alluring, and converting
            potential leads. Here's how we execute that:
          </p>

          <div className="leads-content">
            <div className="leads-strategy">
              <h2>Finding Your Ideal Audience</h2>
              <h3>Search Engine Optimization (SEO)</h3>
              <ul className="services-list">
                {Object.keys(serviceDetails).map((service) => (
                  <li
                    key={service}
                    className={selectedService === service ? "active" : ""}
                    onClick={() => handleServiceClick(service)}
                  >
                    {service}
                  </li>
                ))}
              </ul>
            </div>

            <div className="leads-approaches">
              <div className="approach">
                <h3>
                  {serviceDetails[selectedService]?.title || selectedService}
                </h3>
                <p>
                  {serviceDetails[selectedService]?.description ||
                    "Select a service to see details"}
                </p>

                {approaches[selectedService] && (
                  <ul className="approach-steps">
                    {approaches[selectedService].map((step, index) => (
                      <li key={index}>{step}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="core-principles">
          <h2 className="core-principles-title">
            Just SEO Strongly Believes In These <span>Core Principles</span>
          </h2>
          <p className="core-principles-subtitle">
            At the heart of our success is a dedicated team of SEO specialists
            who bring years of experience in optimizing websites for search
            engines.
          </p>

          <div className="core-principles-cards">
            {/* First Row */}
            <div className="core-principle-card-row">
              {principles.slice(0, 2).map((item, index) => (
                <div className="core-principle-card" key={index}>
                  <div className="core-principle-icon">{item.icon}</div>
                  <div className="core-principle-content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Second Row */}
            <div className="core-principle-card-row">
              {principles.slice(2, 4).map((item, index) => (
                <div className="core-principle-card" key={index + 2}>
                  <div className="core-principle-icon">{item.icon}</div>
                  <div className="core-principle-content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <Testimonial />
      </div>
    </div>
  );
};

export default Body;
